/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './grantVerifications.defs.js'
export * as $defs from './grantVerifications.defs.js'
